import './FullscreenDialog.css'
import {
  Dialog as HeadlessDialog,
  DialogBackdrop,
  DialogPanel,
  Transition,
  TransitionChild
} from '@headlessui/react'
import cx from 'classnames'
import React from 'react'

interface FullscreenDialogProps {
  isOpen: boolean
  close: () => void
  children: React.ReactNode
  onAfterLeave?: () => void
  preventCloseOnOutsideClick?: boolean
  className?: string
}

export function FullscreenDialog({
  isOpen,
  close,
  children,
  onAfterLeave,
  preventCloseOnOutsideClick = false,
  className
}: FullscreenDialogProps) {
  return (
    <Transition show={isOpen}>
      <HeadlessDialog
        onClose={preventCloseOnOutsideClick ? () => {} : close}
        className="fullscreen-dialog-container"
      >
        <TransitionChild
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <DialogBackdrop className="fullscreen-dialog-backdrop" />
        </TransitionChild>

        <TransitionChild
          afterLeave={onAfterLeave}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <div className="fullscreen-dialog-wrapper">
            <DialogPanel
              className={cx('fullscreen-dialog-panel', className)}
              onKeyDown={
                preventCloseOnOutsideClick
                  ? event => {
                      if (event.key === 'Escape') {close()}
                    }
                  : undefined
              }
            >
              {children}
            </DialogPanel>
          </div>
        </TransitionChild>
      </HeadlessDialog>
    </Transition>
  )
}
